import styled from '@emotion/styled';

const Button = styled.button`
  ${(p) => p.theme.font.family.sans}
  font-size: 14px;
  line-height: 1;
  font-weight: 700;
  border-radius: 4px;
  padding: 8px 12px;
  margin: 0;
  outline: 0 !important;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
  transition: background-color ${(p) => p.theme.transitions.hover},
    border-color ${(p) => p.theme.transitions.hover};
  position: relative;
  cursor: pointer;
  pointer-events: all;

  ${(p) =>
    p.theme.mode === 'light'
      ? `
      background: ${p.theme.colors.white};
      border-color: ${p.theme.colors.grey75};
      border-bottom-color: ${p.theme.colors.grey60};
      color: ${p.theme.colors.black};

      &:hover, &:focus {
        background: ${p.theme.colors.grey95};
      }
      ${
        p.active &&
        `
        background: ${p.theme.colors.grey95};
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15),
          0 3px 7px rgba(0, 0, 0, 0.15) inset;
      `
      }
      &:active {
        background: ${p.theme.colors.grey95};
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15),
          0 3px 7px rgba(0, 0, 0, 0.15) inset;
      }
      `
      : `
      background: ${p.theme.colors.grey40};
      border-color: ${p.theme.colors.grey30};
      border-bottom-color: ${p.theme.colors.grey25};
      color: ${p.theme.colors.white};

      &:hover, &:focus {
        background: ${p.theme.colors.grey30};
      }
      ${
        p.active &&
        `
        background: ${p.theme.colors.grey25};
      `
      }
      &:active {
        background: ${p.theme.colors.grey25};
      }
  `}

  ${(p) =>
    p.ghost &&
    `
    background: transparent;
    color: ${p.theme.colors.text};
    border: 1px solid ${p.theme.colors.text};
    box-shadow: none;

    &:hover, &:focus {
      color: ${p.theme.colors.background};
      background: ${p.theme.colors.text};
    }

    &:active {
      background: ${p.theme.colors.grey25};
      border-color: ${p.theme.colors.grey25};
    }
  `}

  ${(p) =>
    p.ghost &&
    p.white &&
    `
      color: white;
      border-color: white;
      &:hover, &:focus {
        color: ${p.theme.colors.black};
        background: white;
      }
      &:active {
        background: ${p.theme.colors.grey95};
        border-color: ${p.theme.colors.grey95};
      }
  `}

  ${(p) =>
    p.ghost &&
    p.accent1 &&
    `
      color: ${p.theme.colors.red};
      background: transparent;
      border-color: ${p.theme.colors.red};

      &:hover, &:focus {
        color: white;
        background: ${p.theme.colors.red};
        border-color: ${p.theme.colors.red};
      }

      &:active {
        color: white;
        background: ${p.theme.colors.red35};
        border-color: ${p.theme.colors.red35};
      }
  `}

  ${(p) =>
    p.ghost &&
    p.accent2 &&
    `
      color: ${p.theme.colors.blue};
      background: transparent;
      border-color: ${p.theme.colors.blue};
      &:hover, &:focus {
        color: white;
        background: ${p.theme.colors.blue};
        border-color: ${p.theme.colors.blue};
      }

      &:active {
        color: white;
        background: ${p.theme.colors.blue35};
        border-color: ${p.theme.colors.blue35};
      }
  `}

  ${(p) =>
    p.circle &&
    `
    width: 34px;
    height: 34px;
    padding: 10px;
    border-radius: 50%;
    line-height: 1;
  `}

  ${(p) =>
    p.insideInput &&
    `
    margin: 0;
    padding: 8px 20px;
    min-height: 38px;
    border-radius: 0 4px 4px 0;
    border-width: 0 0 0 1px;
  `}

  ${(p) =>
    p.clear &&
    `
    width: 28px;
    height: 28px;
    border-radius: 50%;
    box-shadow: none;
    border: none;
    display: flex;
    padding: 0;
    margin: 0 6px 0 0;
    justify-content: center;
    align-items: center;
    color: ${p.theme.colors.background};
    background-color: ${p.theme.mode === 'light' ? p.theme.colors.grey75 : p.theme.colors.grey35};
    &:hover, &:focus {
      background-color: ${p.theme.mode === 'light' ? p.theme.colors.grey65 : p.theme.colors.grey45};
    }
  `}

  ${(p) =>
    p.flat &&
    `
    box-shadow: none;
    background: ${p.theme.colors.red};
    border-color: ${p.theme.colors.red};
    color: white;

    &:hover, &:focus {
      background: ${p.theme.colors.red40};
      border-color: ${p.theme.colors.red40};
    }

    &:active {
      background: ${p.theme.colors.red35};
      border-color: ${p.theme.colors.red35};
    }
  `}

  ${(p) =>
    p.flat &&
    p.accent1 &&
    `
      background: ${p.theme.colors.red};
      border-color: ${p.theme.colors.red};

      &:hover, &:focus {
        background: ${p.theme.colors.red40};
        border-color: ${p.theme.colors.red40};
      }

      &:active {
        background: ${p.theme.colors.red35};
        border-color: ${p.theme.colors.red35};
      }
  `}

  ${(p) =>
    p.flat &&
    p.accent2 &&
    `
      background: ${p.theme.colors.blue};
      border-color: ${p.theme.colors.blue};

      &:hover, &:focus {
        background: ${p.theme.colors.blue40};
        border-color: ${p.theme.colors.blue40};
      }

      &:active {
        background: ${p.theme.colors.blue35};
        border-color: ${p.theme.colors.blue35};
      }
  `}

  ${(p) =>
    p.accent1 &&
    `
    background: ${p.theme.colors.red};
    color: white;
    border-color: ${p.theme.colors.red35};
    border-bottom-color: ${p.theme.colors.red30};

    &:hover, &:focus {
      background:  ${p.theme.colors.red40};
      border-bottom-color: ${p.theme.colors.red25};
    }

    &:active {
      background:  ${p.theme.colors.red35};
    }
  `}

  ${(p) =>
    p.accent2 &&
    `
    background: ${p.theme.colors.blue};
    color: white;
    border-color: ${p.theme.colors.blue35};
    border-bottom-color: ${p.theme.colors.blue30};

    &:hover, &:focus {
      background: ${p.theme.colors.blue40};
      border-bottom-color: ${p.theme.colors.blue25};
    }

    &:active {
      background: ${p.theme.colors.blue35};
    }
  `}

  ${(p) =>
    p.close &&
    `
    width: 40px;
    height: 40px;
    padding: 0;
    position: absolute;
    top: -20px;
    right: -20px;
    border-radius: 50%;
    border-width: 0 0 1px 0;
    background-color: ${p.theme.colors.grey50};
    color: white;
    border-color: ${p.theme.colors.grey40};
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover, &:focus {
      background-color: ${p.theme.colors.grey60};
      border-color: ${p.theme.colors.grey50};
    }
  `}
`;

export default Button;
